import {
  OVEntity,
  OVField,
  OVForm,
  OVSearchable,
  OVSidebar,
  OVTable
} from '@ov-suite/ov-metadata';

@OVEntity('EntryReason', 'yardlink')
@OVForm([['#Entry Reason'], ['value']])
@OVSidebar([['id']])
@OVTable<EntryReason>([
  {
    key: 'value',
    title: 'Reason',
    type: 'string'
  }
])
export class EntryReason {
  @OVField({
    type: 'string',
    title: 'Unique ID',
    sidebar: true,
    generated: true,
    readonly: true
  })
  id: number;

  @OVSearchable()
  @OVField({
    type: 'string',
    title: 'Reason',
    placeholder: 'Required',
    required: true
  })
  value: string;
}
